import type { AmplifyAuthConfig } from '@metron-sweng/metron-auth';

/**
 * Auth configuration shared between Amplify and AuthProvider.
 *
 * Note: Environment variables may be undefined in test environments.
 * Validation of required fields is done in main.tsx at application bootstrap.
 */
export const authConfig: AmplifyAuthConfig = {
  userPoolId: (import.meta.env.VITE_USER_POOL_ID as string) || '',
  userPoolClientId: (import.meta.env.VITE_USER_POOL_CLIENT_ID as string) || '',
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN as string,
  region: (import.meta.env.VITE_AWS_REGION as string) || 'us-west-2',
  identityProvider: import.meta.env.VITE_IDENTITY_PROVIDER as string,
  groupPrefix: 'Wellspring-',
};
